// extracted by mini-css-extract-plugin
export default {"default-column":"TableCell_default-column__UdlT2","undo-icon":"TableCell_undo-icon__4XYEk"};